import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  jp: {
    translation: {
      required: "を入力してください。",
      maxLength: "は、${max}文字以内で入力してください。",
      regex: "の形式が正しくありません。",
      maxNumber: "の形式が正しくありません。",
      minNumber: "の形式が正しくありません。",
      integer: "の形式が正しくありません。",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "jp",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
